<template>
  <div>
    <section>
      <el-row>
        <el-col :span="1"> 
             <img class="avatar" :src="avatar?avatar:require('../../assets/avatar.png')"  width="100" height="100" />
        </el-col>
        <el-col :span="5">
            <el-col :span="24" >
                <el-form :inline="true">
                  <el-form-item  style="margin-bottom: -5px;">
                    <span style="font-size: 25px;">{{ userName }}</span>
                  </el-form-item>
                </el-form>
            </el-col>
            <el-col :span="24">
                <el-form :inline="true">
                  <el-form-item >
                    <span style="font-size: 16px;color: #848181;">用户ID:</span>
                    <span style="font-size: 16px;color: #848181;">{{ userId }}</span>
                  </el-form-item></el-form>
            </el-col>
        </el-col>
        <el-col :span="17" style="height:1px">
        </el-col>
        <el-col :span="2">
            <el-col :span="24" style="margin-top: 10px;">
                <el-form :inline="true">
                  <el-form-item  style="margin-bottom: -5px;">
                     <span style="font-size: 16px;color: #848181;">托管卡券数</span>
                  </el-form-item>
                </el-form>
            </el-col>
            <el-col :span="24">
                <el-form :inline="true">
                  <el-form-item >
                    <span style="font-size: 28px;">{{ couponNum }}张</span>
                  </el-form-item>
                </el-form>
            </el-col>
        </el-col>
      </el-row>
      <el-col :span="24" class="toolbar" style="padding-bottom: 5px">
        <el-form :inline="true">
          <el-form-item class="form-class">
            <el-input v-model="couponName" placeholder="请输入" clearable></el-input>
          </el-form-item>

          <el-form-item class="form-class">
            <el-select v-model="couponType" placeholder="请选择" @change="verifyChanged">
              <el-option
                v-for="item in CouponTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="form-class">
            <el-select multiple v-model="values" placeholder="请选择" @change="verifyChanged">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="form-class">
            <el-button type="primary" v-on:click="getFilterList">查询</el-button>
          </el-form-item >
          <el-form-item class="form-class">
            <el-button type="default" >重置</el-button>
          </el-form-item >
        </el-form>
      </el-col>
      <el-table stripe align="left" :data="tableData" highlight-current-row v-loading="listLoading"
                style="width: 100%;">
        <el-table-column align="center" prop="createTime" label="创建时间" :formatter="formatTime"
                  min-width="40%"></el-table-column>
        <!-- <el-table-column type="index" align="center" prop="id" label="序号" min-width="10%">
        </el-table-column> -->
        <el-table-column align="center" prop="couponName" label="卡券名称" min-width="20%"></el-table-column>
        <el-table-column align="center" prop="merchantName" label="发券商户" min-width="20%"></el-table-column>
        <el-table-column align="center" prop="couponType" label="卡券类型" :formatter="formatCouponType" min-width="20%"></el-table-column>
        <el-table-column align="center" prop="checkStatus" label="状态" :formatter="formatCouponStatus" min-width="20%"></el-table-column>
        <el-table-column align="center" prop="banlanceCount" label="库存" min-width="20%"></el-table-column>
        <el-table-column align="center" prop="getNum" label="领取" min-width="20%">
          <template slot-scope="scope">
            <el-button type="text"  size="small" @click="handleGetDetail(scope.$index, scope.row)">{{scope.row.getNum}}</el-button>
          </template>
        </el-table-column>
          <el-table-column align="center" prop="useNum" label="核销" min-width="20%">
          <template slot-scope="scope">
            <el-button type="text"  size="small" @click="handleUseDetail(scope.$index, scope.row)">{{scope.row.useNum}}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" class="button-bar" fixed='right'>
          <template slot-scope="scope">
            <el-button type="text"  size="small" @click="handleCouponDetail(scope.$index, scope.row)">卡券详情</el-button>
          </template>
			</el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page=currentPage
        :page-sizes="[10, 20, 30, 40]"
        :page-size=pageSize
        layout="total, sizes, prev, pager, next, jumper"
        :total=total>
      </el-pagination>
      <Dialog v-if="isShow" :propsData="propsData" @child-ok="childok" @child-cancel="childcancel"></Dialog>
    </section>
  </div>
</template>

<script>
  import {CouponOptions} from '../details/detail-data.js'
  import Dialog  from '../../views/coupon/couponDetail.vue'
  export default {
    name: "coupon",
    components: {
      Dialog
    },
    data() {
      return {
        isShow:false,
        values: [],
        options: CouponOptions.data,
        create_end_date: '结束日期',
        create_start_date: '开始日期',
        tableDate: null,
        listLoading: false,
        totalAmount: 0,
        userId: '',
        userName: '',
        avatar:null,
        currentPage: 0,
        pageSize: 10,
        total: 0,
        timeInterval: '',
        CouponTypes:[{ label: '全部', value: 0 },{ label: '代金券', value: 1 }, { label: '免单卡', value: 2 },],
        checkStatuss:[{ label: '全部', value: 0 }, { label: '未审核', value: 1 }, { label: '审核未通过', value: 2 }, { label: '审核通过', value: 3 }],

        propsData:{},
        couponNum:0,
        couponName:'',
        couponType:0,
        tableData:[]
      }
    },

    methods: {
      formatTime(row, column) {
        if (!row.createTime) {
          return '';
        }
        return new Date(row.createTime).format("yyyy/MM/dd hh:mm");
      },
      formatCouponType(row, column){
        let temp = this.CouponTypes.filter((item) => {
					return item.value == row.couponType;
				})
				return temp[0].label;
      },
      formatCouponStatus(row, column){
        let temp = this.checkStatuss.filter((item) => {
					return item.value == row.checkStatus;
				})
				return temp[0].label;
      },
      getFilterList() {
				this.currentPage = 1;
				this.getList(this.currentPage);
			},
      handleSizeChange(val) {
				this.pageSize = val;
				this.currentPage = 1;
				this.getList(this.currentPage);
      },
      handleCurrentChange(val) {
				this.currentPage = val;
				this.getList(this.currentPage);
      },
      async getList(index) {
				let condition = {}
				condition.couponName = this.coupenName;
        condition.userId =this.userId;
        condition.currentPage =index;
        condition.pageSize = this.pageSize;
        condition.couponType = this.couponType;
        condition.checkStatus =this.checkStatus;
				try{
					this.listLoading = true;
					let result = await this.$http.post(this,'/coupon/getCouponListByUser', {},condition);
					if (result && result.code == 200) {
            
						this.tableData = result.data.rows;
						this.total = result.data.total;
						this.listLoading = false;
					}
				} catch(e){
					this.listLoading = false;
				}
			},
      handleCouponDetail(index,row){
        this.propsData ={};
        this.propsData.userId =  this.userId;
        this.propsData.couponId = row.id;
        //this.$router.push({ path: '/operateManage/details', query: { userId: row.id,userName: row.nickName } });
      },
      verifyChanged(){
        this.getList(0);
      },
      handleGetDetail(index,row){
          this.$router.push({ path: '/operateManage/coupon/operateCouponCollection', query: { couponId: row.id,shopName:row.merchantName,couponName:row.couponName,avatar:this.avatar,getNum:row.getNum} });
      },
      handleUseDetail(index,row){
          this.$router.push({ path: '/operateManage/coupon/operateCouponCheck', query: { couponId: row.id,shopName:row.merchantName,couponName:row.couponName,avatar:this.avatar,useNum:row.useNum} });

      }
    },
    created() {
      this.userId = this.$route.query.userId
      this.userName = this.$route.query.userName
      this.avatar = this.$route.query.avatar
      this.couponNum = this.$route.query.couponNum
      this.listLoading = true
      this.getList(0);
    }
  }
</script>

<style scoped>

  .toolbar {
    background: #f2f2f2;
    padding: 10px;
    margin: 10px 0px;
  }

  .icon-class {
    font-size: 30px;
    position: relative;
    vertical-align: sub;
    margin-left: 15px;
  }

  .form-class {
    margin-left: 1%;
  }
  .avatar {
    width: 60px;
    height: 60px;
    border-radius: 40px;
}
</style>
